module.exports = __webpack_public_path__ + "static/media/Rubik-BlackItalic.77c7f123.ttf";